import React from "react";
import {
  Container,
  Typography,
  Box,
  TextField,
  Checkbox,
  FormControlLabel,
  Button,
} from "@mui/material";
import { useFormContext } from "../FormContext";

const Last = () => {
  const { formData, updateFormData } = useFormContext();

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    updateFormData({ [name]: type === "checkbox" ? checked : value });
  };

  return (
    <Container maxWidth="xl" disableGutters>
      <Box
        sx={{
          textAlign: "center",
          pt: 4,
          px: { xs: 2, sm: 4, md: 6, lg: 8 },
        }}
      >
        {/* <TextField
          label="Name"
          name="name"
          value={formData.name || ""}
          onChange={handleChange}
          fullWidth
          sx={{ mb: 2, width: { xs: "80%", sm: "80%", md: "70%", lg: "60%" } }}
        />
        <TextField
          label="Mobile Number (Father)"
          name="mobileNumberFather"
          value={formData.mobileNumberFather || ""}
          onChange={handleChange}
          fullWidth
          sx={{ mb: 2, width: { xs: "80%", sm: "80%", md: "70%", lg: "60%" } }}
        />
        <TextField
          label="Mobile Number (Mother)"
          name="mobileNumberMother"
          value={formData.mobileNumberMother || ""}
          onChange={handleChange}
          fullWidth
          sx={{ mb: 2, width: { xs: "80%", sm: "80%", md: "70%", lg: "60%" } }}
        />
        <TextField
          label="Residence Tel"
          name="residenceTel"
          value={formData.residenceTel || ""}
          onChange={handleChange}
          fullWidth
          sx={{ mb: 2, width: { xs: "80%", sm: "80%", md: "70%", lg: "60%" } }}
        />
        <TextField
          label="Email"
          name="useremail"
          value={formData.useremail || ""}
          onChange={handleChange}
          fullWidth
          sx={{ mb: 2, width: { xs: "80%", sm: "80%", md: "70%", lg: "60%" } }}
        /> */}
        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", mb: 2 }}>
          {/* <FormControlLabel
            control={
              <Checkbox
                checked={formData.agreeToTerms || false}
                onChange={handleChange}
                name="agreeToTerms"
                color="primary"
                sx={{
                  color: "black",
                  "&.Mui-checked": {
                    color: "primary.main",
                  },
                  "& .MuiSvgIcon-root": {
                    fontSize: 28,
                    border: "2px solid black",
                    borderRadius: 1,
                  },
                }}
              />
            }
            label=""
          /> */}
          <Typography sx={{ fontSize: "20px", fontStyle: "italic" }}>
            The above terms and conditions have been read, understood, agreed and accepted by the
            Us.
          </Typography>
        </Box>
        {/* <Box sx={{ my: 3 }}>
          <Button variant="contained" color="primary" type="submit">
            Submit
          </Button>
        </Box> */}
      </Box>
    </Container>
  );
};

export default Last;
